/* ===================CRIA PAGAMENTO =================== */
jQuery(document).ready(function () {
  //Grava o pagamento
  $(".bt-registrar-pagamento").on("click", function (e) {
    e.preventDefault();

    var freteChecked = $("input[name=forma-entrega]:checked").val();
    var pagamentoChecked = $("input[name=forma-pagamento]:checked").val();

    if (!freteChecked) {
      showAlert("Atenção", "Escolha a forma de entrega.", "warning");
      return false;
    }

    if (!pagamentoChecked) {
      showAlert("Atenção", "Escolha a forma de pagamento.", "warning");
      return false;
    }

    if ($("#form-pagamento").parsley().validate()) {
      var url_geral = $("#infos").data("url-base");
      var dados = $("#form-pagamento").serialize();
      $.ajax({
        type: "POST",
        url: url_geral + "acoes/app/pagamentos/grava_pagamento.php?acao=insert",
        data: dados,
        beforeSend: function () {
          showLoading();
        },
        success: function (data) {
          console.log(data);
          data = $.parseJSON(data);
          console.log(data);
          hideLoading();
          if (data.status_pagamento != 14) {
            location.href =
              "" +
              url_geral +
              "usuario/confirmacao/order/" +
              data.hash +
              "?status=" +
              data.status_pedido +
              "&pag=" +
              data.status_pagamento +
              "&r=true";
          } else {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação, revise os dados.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception, data) {
          data = $.parseJSON(data);
          hideLoading();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });
});
